module.exports = __webpack_public_path__ + "img/training_right.5e157f86.png";